import { UsersTable } from '@features/users'
import { withTableView } from '@components/enitity/table/Table.view'
import { useTranslation } from 'react-i18next'

export const Users = () => {
  const { t } = useTranslation('users')

  const TableWithView = withTableView(UsersTable, t('users'))

  return <TableWithView />
}
